import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { AuthService } from './../../../services/auth.service';
import { MemberService } from './../../../rest/api/member.service';
import { environment } from './../../../../environments/environment.prod';


@Component({
  selector: 'app-share-space',
  templateUrl: './share-space.component.html',
  styleUrls: ['./share-space.component.scss']
})
export class ShareSpaceComponent implements OnInit {

  @Input() selectedSpace;
  confirmSpaceError;
  confirmSpaceSuccess;
  accessToken: any;
  publicLoader = false;
  bspaceUrl: any;
  iframeCode: any;

  constructor(
    public memberService: MemberService,
    public authService: AuthService
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
    this.bspaceUrl = environment.baseUrl;
  }

  ngOnInit() {
  }

  copyIframeText() {
    setTimeout(() => {
      $('#iframeInput').select();
      document.execCommand('copy');
      $('.copied').text('Copied to clipboard').show().fadeOut(3000);
    }, 100);
  }

}
